/* UTILS */
import restTypes from 'utils/rest/types';
import restStates from 'utils/rest/states';
import restInitState from 'utils/rest/initState';

/* TYPES */
import {
  CLEAR_CORRESPONDENCE_EVENTS,
  CLEAR_CORRESPONDENCE_LIST,
  FETCH_CORRESPONDENCE_EVENTS,
} from 'actions/types';

const initialState = {
  list: [],
};

const claimCorrespondenceRestTypes = restTypes('claimCorrespondence');

const {
  fetchAllStart,
  fetchAllFinished,
  fetchOneStart,
  fetchOneFinished,
  deleteStart,
  deleteFinished,
  updateStart,
  updateFinished,
  createStart,
  createFinished,
} = claimCorrespondenceRestTypes;

const claimCorrespondence = (
  state = { ...restInitState, ...initialState },
  action = {}
) => {
  switch (action.type) {
    case fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };

    case fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        list: action.payload.deliveredNotifications.map((i) => ({
          ...i,
          correspondenceEvents: true,
        })),
        pageCurrent: action.payload.meta && action.payload.meta.currentPage,
        pagesTotal: action.payload.meta && action.payload.meta.totalPages,
      };

    case fetchOneStart:
      return {
        ...state,
        ...restStates.fetchOneStart,
      };

    case fetchOneFinished:
      return {
        ...state,
        ...restStates.fetchOneFinished,
        data: action.payload,
      };

    case deleteStart:
      return {
        ...state,
        ...restStates.deleteStart,
        ...action.payload,
      };

    case deleteFinished:
      return {
        ...state,
        ...restStates.deleteFinished,
        ...action.payload,
      };

    case updateStart:
      return {
        ...state,
        ...restStates.updateStart,
        ...action.payload,
      };

    case updateFinished:
      return {
        ...state,
        ...restStates.updateFinished,
        ...action.payload,
      };

    case createStart:
      return {
        ...state,
        ...restStates.createStart,
      };

    case createFinished:
      return {
        ...state,
        ...restStates.createFinished,
        data: action.payload,
      };

    case CLEAR_CORRESPONDENCE_LIST:
      return {
        ...initialState,
      };

    case FETCH_CORRESPONDENCE_EVENTS:
      return {
        ...state,
        correspondenceEvents: action.payload,
      };

    case CLEAR_CORRESPONDENCE_EVENTS:
      return {
        ...state,
        correspondenceEvents: null,
      };

    default:
      return state;
  }
};

export default claimCorrespondence;
